import { Claims } from "../common/claims";

export class UkMileageRateSettingConfiguration {
    //isEditDisabled: boolean;
    isOverlayEnabled: boolean;
    ownershipTemplateModel: string = null;
    vatRateModel: string;
    isVehicleTypeDropdown: boolean;
    isEffectiveFromValidation: boolean;
    //isOwnershipTemplateDropdownDisabled: boolean;
    isVatRateDropdown: boolean;
    isNewOwnershipType: boolean;
    isPrivateCarTypeSelected: boolean;
    isOtherCarTypeSelected: boolean;
    isAddNewRate: boolean;
    userActionId: number;
    panelHeading: string;
    effictiveFromModel: string;
    //isSlabRateEditDisabled: boolean;
    isOwnershipTemplateDropdown: boolean;
    filterByType: number;
    isFilterByTypeDropdown: boolean;
    filterByTypeModel: string;
    submitted = false;
    isTaxRateFunctionPurchased: boolean;
    showTaxMarketingPopup: boolean;
    claims: Claims;

    isSlabsDivDisplay: boolean;
    isOwnershipTemplateDisable: boolean;
    isOwnershipTemplate_NameBlockhide: boolean;
    //isActivate_LogBlockhide: boolean;
    isOwnershipNameDisable: boolean;
    isEffictiveFromDisabled: boolean;
    isEffictiveFromBlockhide: boolean;
    isResetBussMileDisplay: boolean;
    isSlabRangeFromDisabled: boolean;
    isSlabRangeToDisabled: boolean;
    isSlabRateDisabled: boolean;
    isSlabVatRateDisabled: boolean;
    isSlabDeleteRateDisabled: boolean;
    isSlabAddTierRateDisabled: boolean;
    isCopyIconHide: boolean;
    isRangeToValidationDisplay: boolean = false;
    isActivateValidationDisplay: boolean;
    isAddSlabHover: boolean;
    isDeleteRateBtnHide: boolean;
    isDeleteRateConfirmationDisplay: boolean;
    isCostOfFuelDisable: boolean;
    isOwnershipTypeHide: boolean;
    isOwnershipTypeDisabled: boolean;
    isOwnershipTemplateHide: boolean;
    isOwnershipNameHide: boolean;
    isActiveLogIconHide: boolean;

    popUpModelAlert: boolean;
    popUpModelAlertHeading: string;
    popUpModelAlertContant: string;
    popUpModelAlertButtonText: string;
    selectedWorkerType: number = 0;
    isOwnershipNameDuplicate: boolean = false;
    oldVehicleLabel: string;
    minMileageRate: number = 0.01;
}
